import { Button } from "./button.js";
import { HTTPService } from "../util/httpManager.js";
import { BaseDataSourceComponentProps, BaseDataSourceField } from "./baseComponentProps.js";
import React from "react";
export class SortableList extends React.Component<SortableListProps, { items?: Array<Object> }>{
    private sortableListRef: any;
    private sortableList: any;
    private disabled = true;
    private onItemClick: Function;
    private onButtonClick: Function;

    constructor(props) {
        super(props);
        this._setFunctions();
        this._setData(props);
        this.state = {};
    }

    static getDerivedStateFromProps(props, state) {
        return { items: props.value };
    }

    private _createList(items: Array<Object>) {
        return items.map((item) => {
            const key = item[this.props.field.dataValueField];
            const value = item[this.props.field.dataTextField];
            const displayValue = this.props.field.template ? this._getDisplayValue(item) : value;
            //kendo.guid() bei sortable leider nötig, da der key abhängig von der Reihenfolge sein kann!
            return <li onClick={(e) => { if (!this.props.disabled) this.onItemClick(e, key); }} className="sortable-list__li-element" style={{ cursor: "pointer", margin: "5px", textAlign: "center" }} key={kendo.guid()} data-key={key} data-value={value}>{displayValue}</li>;
        })
    }

    private _createResultArray = (items) => {
        let resultArray: Array<Object> = [];
        for (let i = 0; i < items.length; i++) {
            let dynObject: Object = {};
            dynObject[this.props.field.dataValueField] = +$(items[i]).attr('data-key');
            dynObject[this.props.field.dataTextField] = $(items[i]).attr('data-value');
            resultArray.push(dynObject);
        }
        return resultArray;
    }

    private _setFunctions = () => {
        if (this.props.field.onItemClick) {
            this.onItemClick = this.props.field.onItemClick instanceof Function ? this.props.field.onItemClick : this.props.handleEval(this.props.field.onItemClick)
        }
        else {
            this.onItemClick = () => { };
        }
        if (this.props.field.onButtonClick) {
            this.onButtonClick = this.props.field.onButtonClick instanceof Function ? this.props.field.onButtonClick : this.props.handleEval(this.props.field.onButtonClick)
        }
    }

    private _initialzeSortableList = () => {
        if (this.sortableList == null) {
            this.sortableList = $(this.sortableListRef);
            this.sortableList.sortable({
                update: (event, ui) => { this.positionUpdated(event, ui); },
                disabled: this.disabled || this.props.field.disableSortability
            });
        }
        else {
            this.sortableList.sortable("refresh");
        }
    }

    private _setData = (props: SortableListProps) => {
        this.disabled = props.disabled || false;
        if (props.value != null && props.value !== "") {
        }
        else
            if (props.field.dataSourceUrl != null && props.field.dataSourceUrl !== "") {
                HTTPService.get(props.field.dataSourceUrl)
                    .then(data => {
                        this.setState({ items: data });
                    }
                    );
            }
    }

    private _getDisplayValue = (item: Object) => {
        let templateData = {
            entity: item
        };
        try {
            const template = kendo.template(this.props.field.template)(templateData);
            return <div dangerouslySetInnerHTML={{ __html: template }}></div>
        }
        catch (e) {
            console.error("ERROR template: " + e);
            return "ERROR template";
        }
    }

    positionUpdated = (event, ui) => {
        this.props.onChange(this.props.field, this._createResultArray(this.sortableList.children()));
    }

    componentDidMount() {
        this._initialzeSortableList();
    }

    componentDidUpdate(prevProps, prevState) {
        this._setData(this.props);
        if (this.disabled !== this.props.disabled) {
            this.disabled = this.props.disabled;
            this.sortableList.sortable("option", "disabled", this.disabled);
        }
        this._initialzeSortableList();
    }

    shouldComponentUpdate() {
        return true;
    }

    render() {
        if (this.state.items != null) {
            let button = null;
            if (this.onButtonClick != null) {
                button = <div style={{ width: "auto" }}>
                    <Button readOnly={this.props.disabled} handleClick={() => { this.onButtonClick() }} iconName={"plus"} buttonStyle={{ marginLeft: "5px" } as React.CSSProperties}></Button>
                </div>
            }
            return (
                <div style={{ display: "flex" }}>
                    <div style={{ display: "flex", flex: "1", justifyContent: "center", border: "1px solid #ccc", borderRadius: "16px" }}>
                        <ol ref={(r) => this.sortableListRef = r} style={{ display: "flex", flexDirection: "column", flex: "1", justifyContent: "center" }} >
                            {this._createList(this.state.items)}
                        </ol>
                    </div>
                    {button}
                </div>
            );
        }
        return null;
    }
}
export interface SortableListProps extends BaseDataSourceComponentProps {
    field: SortableListField;
    handleEval(action: string, prepare?: any);
}

export interface SortableListField extends BaseDataSourceField {
    template?: string;
    disableSortability?: boolean;
    onItemClick?: (e: React.MouseEvent<HTMLLIElement>, data: any) => void | string;
    onButtonClick?: (data: any) => void | string;
}